import Character from 'assets/images/characters/CarolinaMariadeJesus/waving-happily.webp';
import {useEffect, useState, useRef} from 'react';
import checkNetworkStatus from 'utils/functions/checkNetworkStatus';
import {Button, Modal} from 'letrus-ui';
import styles from './FinishCompositionModal.module.scss';

interface FinishCompositionModalProps {
  id: string;
  onClose(): void;
  onConfirmFinish(sendToManualReview: boolean): void;
  isCheckReviewReminderModal?: boolean;
}

function FinishCompositionModal({
  id,
  onClose,
  onConfirmFinish,
  isCheckReviewReminderModal = false,
}: FinishCompositionModalProps): JSX.Element {
  const [networkStatus, setNetworkStatus] = useState('online');
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    checkNetworkStatus({
      onlineCallback: () => {
        setNetworkStatus('online');
      },
      offlineCallback: () => {
        setNetworkStatus('offline');
      },
    });

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  const handleFinishClick = () => {
    onConfirmFinish(false);
    setIsButtonDisabled(true);

    timerRef.current = setTimeout(() => {
      setIsButtonDisabled(false);
      timerRef.current = null;
    }, 60000);
  };

  return (
    <Modal id={id}>
      <article className={styles.wrapper}>
        <h1 className={styles.title}>Oba, temos um texto pronto?</h1>

        <p className={styles.description}>
          Antes de entregar, que tal revisar uma última vez? <br /> É comum
          cometermos alguns erros em textos longos, mas, caso você já sinta
          segurança, basta enviar!
        </p>

        {isCheckReviewReminderModal && (
          <div className={styles.checkReviewReminderModal}>
            <figure aria-hidden>
              <img src={Character} alt="Carolina Maria de Jesus" />
            </figure>
            <strong>
              Não esqueça de conferir a sua devolutiva ao final da escrita!
            </strong>
            <span>
              A Letrus utiliza tecnologias inovadoras para criar comentários
              especialmente para você.
            </span>
          </div>
        )}

        <div className={styles.footer}>
          <Button variant="secondary" onClick={onClose}>
            Quero revisar
          </Button>

          <Button
            theme="blue"
            variant="primary"
            onClick={handleFinishClick}
            disabled={isButtonDisabled}
          >
            Enviar texto
          </Button>
        </div>

        {networkStatus === 'offline' && (
          <p className={styles.offlineWarning} data-testid="offlineWarning">
            <b>Lembre-se: </b>
            você concluiu esse passo sem conexão com a <br /> internet - é
            necessário ficar online antes do prazo de terminar!
          </p>
        )}
      </article>
    </Modal>
  );
}

export default FinishCompositionModal;
